(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbx-review-wall"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click", function (e) {
  var btn = e.target.closest("[data-wbx-wall-more]");
  if (!btn) return;
  var wall = btn.closest(".wbx-shell").querySelector(".wbx-wall");
  if (!wall) return;
  var hidden = wall.querySelectorAll(".wbx-wall__card.is-hidden");
  for (var i = 0; i < hidden.length && i < 12; i++) {
    hidden[i].classList.remove("is-hidden");
  }
  if (wall.querySelectorAll(".wbx-wall__card.is-hidden").length === 0) {
    btn.style.display = "none";
  }
});

  } catch(e) { console.error(e); }
})();
})();
